"use client";

import { PublicClientApplication, type Configuration } from "@azure/msal-browser";
import { getEntraMsalConfig } from "@/lib/auth/entra/msal-config";
import { getEntraOAuthRedirectUri } from "@/lib/auth/entra/redirect-uri";

let msalInstance: PublicClientApplication | null = null;
let initPromise: Promise<PublicClientApplication | null> | null = null;

function buildMsalInstance(): PublicClientApplication | null {
    if (typeof window === "undefined") return null;
    if (msalInstance) return msalInstance;

    const cfg = getEntraMsalConfig();
    if (!cfg) return null;

    const config: Configuration = {
        auth: {
            clientId: cfg.clientId,
            authority: cfg.authority,
            knownAuthorities: cfg.knownAuthorities,
            redirectUri: getEntraOAuthRedirectUri(window.location.origin),
            postLogoutRedirectUri: `${window.location.origin}/auth/signin`,
        },
        cache: {
            cacheLocation: "sessionStorage",
        },
    };

    msalInstance = new PublicClientApplication(config);
    return msalInstance;
}

/** Browser MSAL singleton — used by AuthContext when AUTH_PROVIDER=entra (B2.11). */
export function getBrowserMsalInstance(): PublicClientApplication | null {
    return buildMsalInstance();
}

/** Initialize MSAL once before login / redirect handling. */
export async function ensureMsalReady(): Promise<PublicClientApplication | null> {
    const instance = buildMsalInstance();
    if (!instance) return null;
    if (!initPromise) {
        initPromise = instance.initialize().then(() => instance);
    }
    return initPromise;
}
